import { useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { MenuLink, MenuToggle, inactiveToggleStyles, menuToggleStyles } from '@/components/navbar/MoreDropdownItems'
import type { OverflowItem } from '@/components/navbar/navItems'
import { useClickOutside } from '@/hooks/ui/useClickOutside'
import { useTheme } from '@/hooks/ui/useTheme'

interface MoreDropdownProps {
  isOpen: boolean
  onClose: () => void
  items: OverflowItem[]
}

export default function MoreDropdown({ isOpen, onClose, items }: MoreDropdownProps) {
  const dropdownRef = useRef<HTMLDivElement>(null)
  const location = useLocation()
  const { toggleTheme, ThemeIcon, themeLabel } = useTheme()

  useClickOutside(dropdownRef, onClose, isOpen)

  if (!isOpen || items.length === 0) return null

  return (
    <div
      ref={dropdownRef}
      role="menu"
      aria-label="More navigation options"
      className="absolute right-0 top-full mt-1 w-48 bg-elevated border border-theme-border rounded-md shadow-lg z-50 py-1"
    >
      {items.map((item) =>
        item.type === 'link' ? (
          <MenuLink key={item.id} item={item} active={location.pathname === item.to} onClose={onClose} />
        ) : (
          <MenuToggle key={item.id} id={item.id} />
        ),
      )}
      <div className="border-t border-theme-border mt-1 pt-1">
        <button
          onClick={toggleTheme}
          role="menuitem"
          aria-label={`Toggle theme (current: ${themeLabel})`}
          className={`${menuToggleStyles} ${inactiveToggleStyles}`}
        >
          <ThemeIcon className="w-4 h-4" />
          Theme: {themeLabel}
        </button>
      </div>
    </div>
  )
}
